import { render, staticRenderFns } from "./FansMgt.vue?vue&type=template&id=1fb47d28&"
import script from "./FansMgt.vue?vue&type=script&lang=js&"
export * from "./FansMgt.vue?vue&type=script&lang=js&"
import style0 from "./FansMgt.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports